import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {MultiFileUploadService} from './multi-file-upload-service.service';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';

@Component({
    selector: 'app-multi-file-upload',
    templateUrl: './multi-file-upload.component.html',
    styleUrls: ['./multi-file-upload.component.css'],
    standalone: false
})
export class MultiFileUploadComponent implements OnInit {
  selectedFiles: FileList;
  uploadForm: UntypedFormGroup;
  progressInfos = [];
  message = '';
  uploadedFiles = [];
  showProgressBar: boolean;
  showSelectedFiles: boolean;
  fileInfos: Observable<any>;
  files:File[];
  @Output() gotUploadedFiles = new EventEmitter<any>();
  @Input() sentEmails: boolean;
  
  constructor(private uploadService : MultiFileUploadService,private fb: UntypedFormBuilder) {
    this.uploadForm = this.fb.group({
      filePicker: new UntypedFormControl('', Validators.required)
    });
   }

  ngOnInit(): void {
    this.files = [];
  }
  
  ngOnChanges(changes: SimpleChanges): void{
    if(this.sentEmails){
      this.selectedFiles = null;
      this.files = [];
      this.showProgressBar = false;
      this.showSelectedFiles = false;
      this.uploadForm.get('filePicker').setValue('');
      this.uploadForm.get('filePicker').setValidators([Validators.required]);
    }
  }

  selectFiles(event) {
    this.progressInfos = [];
    this.showSelectedFiles = true;
    this.selectedFiles = event.target.files;
    for(let i = 0; i < event.target.files.length; i++){
      this.files.push(event.target.files[i]);
    }
    console.log(this.files);
    this.uploadedFiles = [];
   // this.uploadFiles()
  }

  uploadFiles() {
    this.message = '';
    this.showSelectedFiles = false;
    this.showProgressBar = true;
    /*for (let i = 0; i < this.selectedFiles.length; i++) {
      this.upload(i, this.selectedFiles[i]);
    }*/
    for (let i = 0; i < this.files.length; i++) {
      this.upload(i, this.files[i]);
    }
    this.selectedFiles = null;
  }


  upload(idx, file) {
    this.progressInfos[idx] = { value: 0, fileName: file.name, fileSize: file.size };
  
    this.uploadService.postMultiFile(file).subscribe(
      event => { 
        //if (event.type === HttpEventType.UploadProgress) {
        if (event.status == 'uploading') { 
          //this.progressInfos[idx].value = Math.round(100 * event.loaded / event.total);
          this.progressInfos[idx].value = event.message;
        }
        else if(event.status == 'done') {
          this.uploadedFiles.push(event.message);
          //let myArr = event.message.split('~%');
          //this.progressInfos[idx].fileSize = ''+ myArr[1] + ' MB';
          let size = (+this.progressInfos[idx].fileSize/(1024*1024)).toFixed(3);
          this.progressInfos[idx].fileSize = size + ' MB';
          if(this.files.length == this.uploadedFiles.length){
            this.gotUploadedFiles.emit(this.uploadedFiles);
          }
        
        }/* setTimeout(() => {
          //this.selectedFiles = null;
          //this.showProgressBar = false;
          this.uploadForm.get('filePicker').setValue('');
          this.uploadForm.get('filePicker').setValidators([Validators.required]);
        }, 5000);*/
      },
      err => {
        this.progressInfos[idx].value = 0;
        this.message = 'Could not upload the file:' + file.name;
      });
  }

  removeAttachedFiles(event:any){
    
    let fileName = event.fileName;
    let fileNameWithoutExt = fileName.substring(0,fileName.lastIndexOf('.'));
    //console.log(fileNameWithoutExt);
    for(let i = 0; i < this.progressInfos.length; i++){
      if (this.progressInfos[i].fileName === event.fileName){
        this.progressInfos.splice(i--, 1);
      }
    }
    for(let j = 0; j < this.uploadedFiles.length; j++){
      if(this.uploadedFiles[j].includes(fileNameWithoutExt)){
        this.uploadedFiles.splice(j--,1);
        this.gotUploadedFiles.emit(this.uploadedFiles);
      }
      if(this.uploadedFiles.length == 0){
        this.selectedFiles = null;
        this.showProgressBar = false;
        this.uploadForm.get('filePicker').setValue('');
        this.uploadForm.get('filePicker').setValidators([Validators.required]);
      }
    }
    
  }

  removeSelectedFiles(event:any){
    for(let i = 0; i < this.files.length; i++){
      if (this.files[i].name === event.name){
        this.files.splice(i--, 1);
      }
    }
  }

}
